import { Box, Drawer, Grid } from '@material-ui/core';
import NotificationEmptyBloc from 'components/Notifications/EmptyBloc';
import NotificationHeader from 'components/Notifications/Header';
import NotificationList from 'components/Notifications/List';
import messages from 'components/Notifications/messages';
import {
  NotificationDrawerProps,
  NotificationsGroup,
} from 'components/Notifications/types';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import {
  notificationSelector,
  unReadNotificationsNumberSelector,
} from 'store/user/selectors';

const NotificationDrawer = ({ isOpen, close }: NotificationDrawerProps) => {
  const data = useSelector(notificationSelector);
  const unread = useSelector(unReadNotificationsNumberSelector);
  const { formatMessage } = useIntl();

  return (
    <GaLoadHOC label="Notifications" category={EVENT_CATEGORIES.NOTIFICATIONS}>
      <Drawer anchor="right" onClose={close} open={isOpen}>
        <Box width="500px">
          <Grid container direction="column">
            <Grid item>
              <NotificationHeader
                total={unread}
                close={close}
                title={formatMessage(messages.title)}
              />
            </Grid>
            <Grid item>
              {data.length ? (
                data.map((item: NotificationsGroup) => {
                  return (
                    <NotificationList
                      key={item.month}
                      title={item.month}
                      items={item.notifications}
                    />
                  );
                })
              ) : (
                <NotificationEmptyBloc />
              )}
            </Grid>
          </Grid>
        </Box>
      </Drawer>
    </GaLoadHOC>
  );
};

export default NotificationDrawer;
